import { createFileRoute } from '@tanstack/react-router'

import { RoleGate } from '@/components/guards'
import { ReminderScheduleSettingsPage } from '@/pages/settings/organization/ReminderScheduleSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/reminders/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <RoleGate requires="ADMIN">
      <ReminderScheduleSettingsPage />
    </RoleGate>
  )
}
